var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatabricks = function SvgDatabricks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#databricks_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3621",
    d: "M16 11.848v-2.82l-.32-.19-7.66 4-7.262-3.81V7.39l7.262 3.772 8.02-4.152V4.229l-.32-.19-7.7 4.037L1.037 4.42 8.02.762l5.626 2.933.439-.228v-.305L8.02 0 0 4.152v.42l8.02 4.19 7.262-3.81V6.63l-7.262 3.81L.32 6.4 0 6.59v2.82l8.02 4.152 7.262-3.772v1.639l-7.262 3.81-7.7-4-.32.19v.419L8.02 16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "databricks_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDatabricks;